module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"enterTheAnswer":"Введите ответ"}}')
  delete Component.options._Ctor
}
